import { OrgLogo } from "components/Logo/OrgLogo";
import { StatTableCellProps } from "components/StatsTable/StatTableColumn";
import { FlexRow } from "styles/layout";
import { StatTableOrgLogoNameColumn } from "./OrgLogoNameColumn";
import { OrgLogoContainer, OrgLogoNameCell, OrgName } from "./styles";

interface Props<T>
  extends StatTableCellProps<T, StatTableOrgLogoNameColumn<T>> {}

export function StatTableOrgLogoNameCell<T>({
  stats,
  column,
  columnIdx,
  frozenOffset,
}: Props<T>) {
  const orgId = column.orgIdGetter(stats);
  const name = column.nameGetter(stats);
  return (
    <OrgLogoNameCell
      key={`${columnIdx} orglogoname ${orgId}`}
      highlight={column.highlight}
      frozenWidth={column.frozenWidth}
      frozenOffset={frozenOffset}
      border={column.border}
    >
      <FlexRow>
        <OrgLogoContainer smallerSize={column.smallerSize}>
          <OrgLogo id={orgId} />
        </OrgLogoContainer>
        <OrgName>{name}</OrgName>
      </FlexRow>
    </OrgLogoNameCell>
  );
}
